import { apiService } from 'services/axiosHandler';

const path = 'members';

export const getMemberRequest = async (params = undefined, selfRole = undefined) => {
    let headers;
    if(selfRole){
        headers = {
            'x-sipekad-self-role': selfRole
        }
    }
    
    const req = await apiService.get(`/${path}`, { 
        params,
        headers
    });

    if (req.status !== 200) {
        throw req.data.message || req.statusText || req
    }

    return req.data;
};

export const addMemberRequest = async (payload, selfRole = undefined) => {
    let headers;
    if(selfRole){
        headers = {
            'x-sipekad-self-role': selfRole
        }
    }
    
    const req = await apiService.post(`/${path}`, payload, { headers });

    if (req.status !== 201) {
        throw req.data.message || req.statusText || req
    }

    return req.data;
};
  
export const updateMemberRequest = async (id, payload, selfRole = undefined) => {
    let headers;
    if(selfRole){
        headers = {
            'x-sipekad-self-role': selfRole
        }
    }

    const req = await apiService.patch(`/${path}/${id}`, payload, { headers });

    if (req.status !== 200) {
        throw req.data.message || req.statusText || req
    }

    return req.data;
};
  
export const deleteMemberRequest = async (id, selfRole = undefined) => {
    let headers;
    if(selfRole){
        headers = {
            'x-sipekad-self-role': selfRole
        }
    }

    const req = await apiService.delete(`/${path}/${id}`, { headers });

    if (req.status !== 204) {
        throw req.data.message || req.statusText || req
    }

    return req.data;
};
  
export const updateMemberSelfRequest = async (id, payload) => {
    const req = await apiService.patch(`/${path}/${id}/self`, payload, {});

    if (req.status !== 200) {
        throw req.data.message || req.statusText || req
    }

    return req.data;
};

export const getMemberOverviewRequest = async (id, params = undefined, selfRole = undefined) => {
    let headers;
    if(selfRole){
        headers = {
            'x-sipekad-self-role': selfRole
        }
    }

    const req = await apiService.get(`/${path}/${id}/overview`, {
        params,
        headers
    });

    if (req.status !== 200) {
        throw req.data.message || req.statusText || req
    }

    return req.data;
};